/* ============================================================
   EXON — product reviews island (R2)
   Parses the hidden Judge.me widget metafield and paints OUR dark
   reviews block (score ring · "מבוסס על N ביקורות מאומתות" · rating
   histogram · dark review cards with verified badge + "קראו עוד").
   "כתבו ביקורת" / "לכל הביקורות" reveal the live (hidden) Judge.me
   widget in a modal and proxy-click its own form — Judge.me keeps
   owning submission. No content is ever invented: everything rendered
   comes straight out of the metafield markup. All review text is set
   via textContent (never innerHTML) so user copy can't inject markup.
   ============================================================ */
(function () {
  'use strict';

  var CIRC = 2 * Math.PI * 40; // ring radius 40 → circumference
  var CLAMP_CHARS = 190;       // body length past which we clamp + "קראו עוד"

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var sections = document.querySelectorAll('[data-reviews-island]');
    for (var i = 0; i < sections.length; i++) {
      try { initSection(sections[i]); } catch (e) { /* never break the page */ }
    }
  });

  function initSection(sec) {
    var tpl = sec.querySelector('template[data-jdgm-source]');
    if (!tpl) return;

    var i18n = {
      summaryPre: sec.getAttribute('data-i18n-summary-pre') || '',
      summaryPost: sec.getAttribute('data-i18n-summary-post') || '',
      readMore: sec.getAttribute('data-i18n-read-more') || 'Read more',
      empty: sec.getAttribute('data-i18n-empty') || '',
      write: sec.getAttribute('data-i18n-write') || 'Write a review',
      verified: sec.getAttribute('data-i18n-verified') || 'Verified purchase',
      all: sec.getAttribute('data-i18n-all') || 'Read all reviews',
      close: sec.getAttribute('data-i18n-close') || 'Close'
    };

    var isHe = (document.documentElement.getAttribute('lang') || '').indexOf('he') === 0 ||
               document.documentElement.dir === 'rtl';

    var data = parseWidget(tpl.content);
    render(sec, data, i18n, isHe);
    wireModal(sec, i18n);

    // The judgeme_core embed hydrates the live #judgeme_product_reviews after
    // load; if it ever ends up carrying MORE reviews than the metafield inlined
    // (e.g. a re-render), re-parse once and repaint so we surface the richer set.
    observeHydration(sec, data, i18n, isHe);
  }

  /* ---------- parse ---------- */
  function parseWidget(root) {
    var widg = root.querySelector('.jdgm-rev-widg');
    var count = widg ? (parseInt(widg.getAttribute('data-number-of-reviews'), 10) || 0) : 0;
    var avg = widg ? (parseFloat(widg.getAttribute('data-average-rating')) || 0) : 0;

    // histogram: rating(5..1) → percentage
    var hist = {};
    var rows = root.querySelectorAll('.jdgm-histogram__row[data-rating]');
    for (var i = 0; i < rows.length; i++) {
      var r = parseInt(rows[i].getAttribute('data-rating'), 10);
      if (!r) continue; // skip the clear-filter row (data-rating=null)
      hist[r] = {
        pct: parseFloat(rows[i].getAttribute('data-percentage')) || 0,
        freq: parseInt(rows[i].getAttribute('data-frequency'), 10) || 0
      };
    }

    // reviews
    var reviews = [];
    var revs = root.querySelectorAll('.jdgm-rev');
    for (var j = 0; j < revs.length; j++) {
      var rev = revs[j];
      var ratingEl = rev.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? (parseInt(ratingEl.getAttribute('data-score'), 10) || 0) : 0;
      var author = txt(rev.querySelector('.jdgm-rev__author'));
      var title = txt(rev.querySelector('.jdgm-rev__title'));
      var bodyEl = rev.querySelector('.jdgm-rev__body');
      var body = bodyEl ? bodyText(bodyEl) : '';
      var verified = rev.getAttribute('data-verified-buyer') === 'true';
      var tsEl = rev.querySelector('.jdgm-rev__timestamp');
      var ts = tsEl ? (tsEl.getAttribute('data-content') || '') : '';
      if (!author && !title && !body) continue; // skip empties
      reviews.push({ score: score, author: author, title: title, body: body, verified: verified, ts: ts });
    }

    return { count: count, avg: avg, hist: hist, reviews: reviews };
  }

  function txt(el) { return el ? (el.textContent || '').trim() : ''; }

  // preserve paragraph / <br> breaks as newlines, drop other markup
  function bodyText(el) {
    var clone = el.cloneNode(true);
    var brs = clone.querySelectorAll('br');
    for (var i = 0; i < brs.length; i++) brs[i].replaceWith('\n');
    var ps = clone.querySelectorAll('p');
    for (var k = 0; k < ps.length; k++) {
      if (k > 0) ps[k].insertBefore(document.createTextNode('\n'), ps[k].firstChild);
    }
    return (clone.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
  }

  /* ---------- render ---------- */
  function render(sec, data, i18n, isHe) {
    var block = sec.querySelector('[data-rev-block]');
    var empty = sec.querySelector('[data-rev-empty]');
    var badge = sec.querySelector('[data-rev-count]');

    // count badge in the section head
    if (badge && data.count > 0) {
      badge.textContent = String(data.count);
      badge.hidden = false;
    }

    if (!data.count || !data.reviews.length) {
      renderEmpty(empty, i18n);
      if (block) block.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    // wipe + rebuild the block
    while (block.firstChild) block.removeChild(block.firstChild);

    block.appendChild(scoreCol(data, i18n));
    block.appendChild(listCol(data, i18n, isHe));

    if (empty) empty.hidden = true;
    block.hidden = false;
  }

  function renderEmpty(empty, i18n) {
    if (!empty) return;
    while (empty.firstChild) empty.removeChild(empty.firstChild);
    var p = document.createElement('p');
    p.textContent = i18n.empty;
    empty.appendChild(p);
    empty.appendChild(makeBtn(i18n.write, 'btn btn-ghost rev-write', 'write'));
  }

  function scoreCol(data, i18n) {
    var col = el('div', 'rev-score glass-chip');
    col.appendChild(ring(data.avg));

    var summary = el('span', 'muted');
    summary.style.fontSize = '11.5px';
    summary.style.textAlign = 'center';
    summary.textContent = i18n.summaryPre + ' ' + data.count + ' ' + i18n.summaryPost;
    col.appendChild(summary);

    col.appendChild(bars(data.hist));
    col.appendChild(makeBtn(i18n.write, 'btn btn-ghost rev-write', 'write'));
    return col;
  }

  function ring(avg) {
    var frac = Math.max(0, Math.min(1, avg / 5));
    var wrap = el('div', 'ring-wrap ltr');
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '104'); svg.setAttribute('height', '104');
    svg.setAttribute('viewBox', '0 0 104 104'); svg.setAttribute('aria-hidden', 'true');

    var track = document.createElementNS(NS, 'circle');
    setAttrs(track, { cx: 52, cy: 52, r: 40, fill: 'none', stroke: 'rgba(255,255,255,0.08)', 'stroke-width': 7 });
    svg.appendChild(track);

    var prog = document.createElementNS(NS, 'circle');
    setAttrs(prog, {
      cx: 52, cy: 52, r: 40, fill: 'none', stroke: 'url(#exonRingGrad)',
      'stroke-width': 7, 'stroke-linecap': 'round',
      'stroke-dasharray': CIRC.toFixed(2),
      'stroke-dashoffset': (CIRC * (1 - frac)).toFixed(2),
      transform: 'rotate(-90 52 52)'
    });
    prog.classList.add('rev-ring-prog');
    svg.appendChild(prog);

    var defs = document.createElementNS(NS, 'defs');
    var grad = document.createElementNS(NS, 'linearGradient');
    setAttrs(grad, { id: 'exonRingGrad', x1: 0, y1: 0, x2: 1, y2: 1 });
    grad.appendChild(stop(NS, '0%', '#33e7bb'));
    grad.appendChild(stop(NS, '100%', '#00e5ff'));
    defs.appendChild(grad);
    svg.appendChild(defs);
    wrap.appendChild(svg);

    var val = el('div', 'ring-val');
    var b = document.createElement('b');
    b.textContent = fmtAvg(avg);
    val.appendChild(b);
    val.appendChild(star(11));
    wrap.appendChild(val);
    return wrap;
  }

  function stop(NS, off, color) {
    var s = document.createElementNS(NS, 'stop');
    s.setAttribute('offset', off); s.setAttribute('stop-color', color);
    return s;
  }

  function bars(hist) {
    var box = el('div', 'rev-bars');
    for (var r = 5; r >= 1; r--) {
      var pct = hist[r] ? hist[r].pct : 0;
      var row = el('div', 'rev-bar-row ltr');
      var num = document.createElement('span'); num.textContent = String(r); row.appendChild(num);
      var bar = el('div', 'rev-bar');
      var fill = document.createElement('span');
      fill.style.width = pct + '%';
      bar.appendChild(fill); row.appendChild(bar);
      var lbl = el('span', 'muted'); lbl.textContent = Math.round(pct) + '%'; row.appendChild(lbl);
      box.appendChild(row);
    }
    return box;
  }

  function listCol(data, i18n, isHe) {
    var list = el('div', 'rev-list');
    for (var i = 0; i < data.reviews.length; i++) {
      list.appendChild(card(data.reviews[i], i18n, isHe));
    }
    // reveal the full, live Judge.me list (paginated) when there is more than
    // the metafield inlined, or simply to browse everything.
    if (data.count > data.reviews.length) {
      var foot = el('div', 'rev-foot');
      var btn = makeBtn(i18n.all + ' (' + data.count + ')', 'btn btn-ghost rev-all-btn', 'all');
      foot.appendChild(btn);
      list.appendChild(foot);
    }
    return list;
  }

  function card(rev, i18n, isHe) {
    var item = el('div', 'rev-item sheen');

    var head = el('div', 'rev-head');
    var av = el('span', 'avatar-sm');
    av.textContent = firstLetter(rev.author);
    head.appendChild(av);

    var who = el('div', 'rev-who');
    var name = document.createElement('b');
    name.textContent = rev.author || '';
    who.appendChild(name);

    var meta = el('span', 'rev-verified');
    if (rev.verified) meta.appendChild(shield());
    var metaTxt = document.createElement('span');
    var when = relTime(rev.ts, isHe);
    metaTxt.textContent = (rev.verified ? i18n.verified : '') +
      (rev.verified && when ? ' · ' : '') + (when || '');
    meta.appendChild(metaTxt);
    who.appendChild(meta);
    head.appendChild(who);

    if (rev.score > 0) {
      var stars = el('span', 'rev-stars sm');
      for (var s = 0; s < rev.score; s++) stars.appendChild(star(11));
      head.appendChild(stars);
    }
    item.appendChild(head);

    if (rev.title) {
      var title = el('b', 'rev-title');
      title.textContent = rev.title;
      item.appendChild(title);
    }

    if (rev.body) {
      var body = el('p', 'rev-body');
      body.textContent = rev.body;
      item.appendChild(body);
      if (rev.body.length > CLAMP_CHARS) {
        body.classList.add('clamp');
        var more = makeBtn(i18n.readMore, 'rev-more', null);
        more.addEventListener('click', function (b) {
          return function () { b.classList.remove('clamp'); this.remove(); };
        }(body));
        item.appendChild(more);
      }
    }
    return item;
  }

  /* ---------- modal (hosts the real Judge.me widget + form) ---------- */
  function wireModal(sec, i18n) {
    var modal = sec.querySelector('[data-jdgm-modal]');
    if (!modal) return;

    // NOTE: our scroll-lock class is intentionally NOT jdgm-* — Judge.me toggles
    // its own `jdgm-modal-open` on <html> for its native popup, so we stay clear.
    function reveal() {
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('exon-rev-lock');
      var close = modal.querySelector('[data-jdgm-close]');
      if (close) { try { close.focus(); } catch (e) {} }
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('exon-rev-lock');
    }

    // "כתבו ביקורת" → proxy-click Judge.me's own write link. Most stores (incl.
    // this one) are configured with a POPUP form, which Judge.me appends to
    // <body> as .jdgm-write-review-modal and fully owns — so we do NOT stack our
    // own modal. Only if no popup appears (an EMBEDDED/inline form config) do we
    // reveal our modal so the inline form, which lives inside our hidden widget,
    // becomes visible.
    function write() {
      var link = modal.querySelector('.jdgm-write-rev-link');
      if (link) { try { link.click(); } catch (e) {} }
      setTimeout(function () {
        var pop = document.querySelector('.jdgm-write-review-modal, .jdgm-review-widget-modal');
        if (!pop || pop.offsetParent === null) reveal();
      }, 360);
    }

    // delegate: [data-rev-action] buttons anywhere in this section
    sec.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-rev-action]') : null;
      if (!t || !sec.contains(t)) return;
      e.preventDefault();
      if (t.getAttribute('data-rev-action') === 'write') write();
      else reveal(); // "לכל הביקורות" → reveal the full live list
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-jdgm-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }

  /* ---------- hydration safety net ---------- */
  function observeHydration(sec, data, i18n, isHe) {
    if (typeof MutationObserver === 'undefined') return;
    var live = sec.querySelector('#judgeme_product_reviews');
    if (!live) return;
    var done = false;
    var obs = new MutationObserver(function () {
      if (done) return;
      var fresh = parseWidget(live);
      if (fresh.reviews.length > data.reviews.length) {
        done = true;
        obs.disconnect();
        render(sec, fresh, i18n, isHe);
      }
    });
    obs.observe(live, { childList: true, subtree: true });
    // stop watching after a while regardless — hydration settles fast
    setTimeout(function () { obs.disconnect(); }, 8000);
  }

  /* ---------- small builders / helpers ---------- */
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }
  function setAttrs(node, map) { for (var k in map) node.setAttribute(k, map[k]); }

  function makeBtn(label, cls, action) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.textContent = label;
    if (action) b.setAttribute('data-rev-action', action);
    return b;
  }

  function star(size) {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    setAttrs(svg, { width: size, height: size, viewBox: '0 0 24 24', fill: 'currentColor', 'aria-hidden': 'true' });
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', 'm12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01z');
    svg.appendChild(path);
    return svg;
  }

  function shield() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    setAttrs(svg, { width: 11, height: 11, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' });
    var p1 = document.createElementNS(NS, 'path');
    p1.setAttribute('d', 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z');
    var p2 = document.createElementNS(NS, 'path');
    p2.setAttribute('d', 'm9 12 2 2 4-4');
    svg.appendChild(p1); svg.appendChild(p2);
    return svg;
  }

  function firstLetter(name) {
    if (!name) return '?';
    var ch = name.trim().charAt(0);
    return ch ? ch.toUpperCase() : '?';
  }

  function fmtAvg(n) {
    if (!n) return '0.0';
    var r1 = Math.round(n * 10) / 10;
    var r2 = Math.round(n * 100) / 100;
    return (r2 === r1) ? r1.toFixed(1) : r2.toFixed(2);
  }

  function relTime(ts, isHe) {
    if (!ts) return '';
    // "2022-01-19 10:17:10 UTC" → ISO
    var iso = ts.replace(' UTC', 'Z').replace(' ', 'T');
    var then = Date.parse(iso);
    if (isNaN(then)) return '';
    var sec = (then - Date.now()) / 1000; // negative for the past
    var abs = Math.abs(sec);
    var units = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60]];
    try {
      var rtf = new Intl.RelativeTimeFormat(isHe ? 'he' : 'en', { numeric: 'auto' });
      for (var i = 0; i < units.length; i++) {
        if (abs >= units[i][1]) return rtf.format(Math.round(sec / units[i][1]), units[i][0]);
      }
      return rtf.format(Math.round(sec / 60), 'minute');
    } catch (e) {
      // Intl unavailable → plain date
      try { return new Date(then).toLocaleDateString(isHe ? 'he-IL' : 'en'); } catch (e2) { return ''; }
    }
  }
})();
